import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
  filas: [],
  fila: {},
  filaUse: {},
  audios: [],
  musicasEmEspera: [],
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
